import { Designer } from "@brg/api"
import { Avatar, Dropdown, FlexBox, IUseToasts, useBreakpoint } from "@brg/ui"
import { CoreContainer, LayoutConst } from "core/modules"
import { FC, lazy, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link, useHistory, useLocation } from "react-router-dom"
import { ErrorNotAllowedGeneric } from "shared/components/error-frames/error-not-allowed-generic"
import { ProjectsSearchBar } from "shared/components/projectsSearchBar/projectsSearchBar"
import { MagicBoxRow } from "shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar"
import CountriesList from "shared/constants/countriesList"
import { isServer } from "shared/constants/isServer"
import { CreateLinkTo } from "shared/constants/linkTo"
import { CombinedEvents } from "shared/helpers/projectEvents"
import useQueryState from "shared/hooks/useQueryState"
import { SortIcon } from "shared/icons"
import MergeAccountsIcon from "shared/icons/MergeAccountsIcon"
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation"
import {
  ProfileFoldersProps,
} from "shared/reducers/ProfileFoldersSlice"
import styled, { DefaultTheme } from "styled-components"
import ProjectsButchControllerUltimate from "../../../core/controllers/ProjectsButchControllerUltimate"
import { AppTester } from "../../../supporting"
import { ErrorLoadingResources } from "../../components/error-frames"
import { DesignerTooltip } from "../../components/tooltips"
import { DesignerTab } from "../../constants/designerTab"
import { ComputedDesigner } from "../../helpers/computeData"
import { MobileFilterSort } from "../explore/exploreView"
import DesignerAlumni from "./components/designerAlumni"
import { DesignerLayout } from "./components/designerLayout"
import DesignerOpaButton from "./components/designerOpaButton"
import { ADDITIONAL_TABS_SIGN } from "./components/designerSliderItem"
import { DesignerSocialNetwork } from "./components/designerSocialNetwork"
import { EMPTY_CONTENT_TAB } from "./components/NoProjectsContent"
import { CreateChannelButton } from "./components/subscribe/CreateChannelButton"
import { ApplyMagistracyButton } from "./components/subscribe/ApplyMagistracyButton"
import { ServiceLink, Title } from "./designer"
import { AboutText, MergeAccountsWrapper, MobileButton, ProfileAbsoluteMoreContainer, ShowMoreContent } from "./styles"
import { SubscribeController } from "shared/components/Subscribe/SubscribeController"
import { BackdropContainer } from "shared/components/projectCard/ProjectCardTools";
import { ReactComponent as MoreCircleSvg } from 'shared/components/projectCard/assets/more-circle.svg';
import { ExploreButtonFilled } from "../explore/styles"
import DesignerRole from "./components/designerRole"
import { SortingTypeIndex } from "shared/constants/sortingType"

const DesignerFolders = isServer
    ? FlexBox
    : lazy(() => import("./components/DesignerFolders/DesignerFolders"));

const SubscribeInfo = isServer
    ? FlexBox
    : lazy(() => import("./components/subscribe/SubscribeInfo"));

const MetaTags = isServer
  ? FlexBox
  : lazy(() => import("../../components/MetaTags"))
const DesignerPageMobile = isServer
  ? FlexBox
  : lazy(() => import("./__mobile__/designer"))

const DesignerSlider = isServer
  ? FlexBox
  : lazy(() => import("./components/designerSlider"))

const DesignerCoreContainer = styled(CoreContainer)`
  margin-top: 14px;
  margin-bottom: 40px;

  @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: 10px;
  }

  .grid-w {
    padding-bottom: 24px !important;
    overflow: visible;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    .white_theme_project_underline {
      z-index: 0;
    }
  }

`

type SortFilter = { projectFilter: number; limit: number }
type NoProjects = { all: boolean; tab: boolean }
type FilterList = { authorTopProjectsFilter: any }

type PropsT = {
  activeTabKey: string
  addTab: string
  // buttons: ReactNode
  canViewCompetitions: boolean
  canViewDrafts: boolean
  computedDesigner: ComputedDesigner
  contentIsLoading: boolean
  counts: any
  designer?: Designer
  filterList: FilterList
  hasEditProfilePolicy: boolean
  handlers: CombinedEvents
  isBooks: boolean
  isLoadingError: boolean
  isGeo: boolean
  ignoreContext?: boolean
  isMobile: boolean
  isMe?: boolean
  isSubscribed?: boolean
  isIqMediia: boolean
  is744BP: boolean
  is743: boolean
  isNoProjects?: boolean
  noProjects?: NoProjects
  noProjectsRef: any
  onContextClick: () => void
  onTabChange: (tab: string, addTab?: string) => void
  profile: any
  ParticipantOPA?: boolean
  setTagId: (v: any) => void
  sortFilter: SortFilter
  serviceLinks: any
  shouldDisplayRoles: boolean
  tagId: string
  tabDetermined: boolean
  theme: DefaultTheme
  toasts: IUseToasts
  whiteTheme?: boolean
  hasShowcaseProjects?: boolean
  shouldDisplayStudentRole?: boolean,
  currentFolder?: string,
}

export const DesignerContent: FC<PropsT> = ({
  activeTabKey,
  addTab,
  canViewCompetitions,
  canViewDrafts,
  computedDesigner,
  contentIsLoading,
  counts,
  // contexts,
  designer,
  filterList,
  handlers,
  hasEditProfilePolicy,
  hasShowcaseProjects,
  is744BP,
  is743,
  isBooks,
  isGeo,
  isSubscribed,
  isIqMediia,
  isLoadingError,
  isMobile,
  isMe,
  isNoProjects,
  noProjectsRef,
  noProjects,
  onContextClick,
  onTabChange,
  ParticipantOPA,
  profile,
  serviceLinks,
  setTagId,
  shouldDisplayRoles,
  shouldDisplayStudentRole,
  sortFilter,
  tabDetermined,
  tagId,
  theme,
  whiteTheme,
    currentFolder,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { accountId: id = "" } = designer || {}
  const context = `profile${id}`
  const storedSorting = localStorage.getItem("brg_sorting")
  const defaultSorting = useMemo(() => {
    if (AppTester.isDeziiignContext()) {
      return 1;
    }
    return storedSorting || 20;
  }, []);
  const [
    { sorting = defaultSorting, showcase, folderId },
    setQueryParams,
  ] = useQueryState()

    const is470 = useBreakpoint(470);

  const isTab = useBreakpoint(1200)

  // // Доп. флаги
  const isEmployee =
    computedDesigner?.globalTypes?.includes("Employee") === true
  const isCooperator =
    computedDesigner?.globalTypes?.includes("Cooperator") === true
  const isAlumni =
    designer?.globalTypes !== null &&
    designer?.globalTypes?.includes("hsealumni")
  const isLPUEmployee =
    computedDesigner?.globalTypes?.includes("lpuemployee") === true
  const isStudent =
    computedDesigner?.globalTypes?.includes("Student") === true &&
    !isCooperator &&
    !isEmployee
  const isIfCIDStudent =
    !!computedDesigner?.globalTypes?.includes("Hsecreativestudent")

  const isLPU = AppTester.isLPUDesign()
  const isHSE = AppTester.isHSEDesign()
  const isMedia = AppTester.isMediiia();
  const isStartHSE = AppTester.isStartHSE();
  const { i18n } = useTranslation()

  const designerTeam = isIfCIDStudent ? t("ifcid") : computedDesigner.contextId

  // TODO Временная логика для отображения пункта магазин в дропдауне сортировки
  const withShopFilter = useMemo(() => ({
    ...sortFilter,
    ...(Number(sorting) === Number(SortingTypeIndex.shop) ? { hasProductCards: true} : {}),
  }), [sortFilter, sorting]);


  const hideAdditionalTabs = false

  const additionalCount = useMemo(
    () => ({
        // [DesignerTab.subscriptionsProjects]:
        //     counts[DesignerTab.subscriptionsProjects] || 0,
          //@ts-ignore
          [DesignerTab.subscriptions]:
            counts[DesignerTab.subscriptions] || 0,
          //@ts-ignore
          [DesignerTab.subscribers]:
            counts[DesignerTab.subscribers] || 0,
          [DesignerTab.educationSubscribes]:
            counts[DesignerTab.educationSubscribes] || 0,
          
      ...(hideAdditionalTabs
        ? {}
        : {
            //@ts-ignore
            [DesignerTab.workingMaterialsAuthor]:
              counts[DesignerTab.workingMaterialsAuthor],
            //@ts-ignore
            [DesignerTab.workingMaterialsCoauthor]:
              counts[DesignerTab.workingMaterialsCoauthor],
            //@ts-ignore
            [DesignerTab.workingMaterialsStudents]:
              counts[DesignerTab.workingMaterialsStudents],
          }),
    }),
    [counts, isMedia]
  )

  const roleString = useMemo(() => {
    const rolesArray = []

    if (isHSE) {
      if (isEmployee) {
        rolesArray.push(t("teacher_at_mob"))
      } else if (isCooperator) {
        rolesArray.push(t("cooperator_at_mob"))
      }
    }

    if (isLPU && isLPUEmployee) {
      rolesArray.push(t("teacher_at_mob"))
    }

    if (shouldDisplayStudentRole) {
      if (isStudent || isIfCIDStudent) {
        if (
          designer &&
          designer.rolesList &&
          designer.rolesList.includes("DPO")
        ) {
          rolesArray.push(t("listener_at_mob"))
        } else {
          rolesArray.push(t("student_at_mob"))
        }
      }

      if (rolesArray.length === 0) {
        return ""
      }

      const roles = rolesArray.join(" " + t("role_and") + " ")

      return isMobile ? roles + " " + t("role_at") : roles + " " + t("role_at")
    }

    return ""
  }, [isMobile, isEmployee, isCooperator, t, isLPUEmployee])

  const cityString = useMemo(() => {
    if (
      designer &&
      designer.rolesList &&
      designer.rolesList.includes("hseprm")
    ) {
      return "(" + t("online_bachelors_degree") + ")"
    } else {
      return ""
    }
  }, [designer, t])

  const requestTab = useMemo(() => {
    if (!isMe && isNoProjects) {
      return EMPTY_CONTENT_TAB
    } else if (activeTabKey === DesignerTab.subscribe) {
      return addTab;
    } else if (activeTabKey === ADDITIONAL_TABS_SIGN) {
      return addTab
    }
    return activeTabKey
  }, [isMe, isNoProjects, activeTabKey, addTab])

  //костыль под кавычки, если будут проблемы с другими символами, то надо сделать что-то нормальное в showMore
  const aboutQuotesSanitized = useMemo(() => {
    const leftQuotes = typeof computedDesigner.about === 'string'? computedDesigner.about.replaceAll('&laquo;', '«') : ''
    const rightQuotes = typeof leftQuotes === 'string'? leftQuotes.replaceAll('&raquo;', '»') : ''
    return rightQuotes
  }, [computedDesigner?.about])

  const sortingMethods = useMemo(() => {
    if (AppTester.isDeziiignContext()) {
      return [1, 2, 30];
    }
    return [1, 2, 20, 30];
  }, []);

  const sortingLine = useMemo(() => {
    if (folderId || currentFolder === ProfileFoldersProps.create) {
      return null
    }

    if (
      !hasShowcaseProjects ||
      ![
        DesignerTab.author,
        DesignerTab.students,
        DesignerTab.coauthor,
        DesignerTab.books,
      ]
        //@ts-ignore
        ?.includes(activeTabKey)
    ) {
      return null
    }

    const showcaseVisible = [
      "projects",
      "coauthor",
      "author",
      "students",
      "books",
    ]?.includes(activeTabKey)

    return (
      <FlexBox
        justifyMobile={is743 ? "space-between" : "start"}
        offsetTop={contentIsLoading ? -8 : 16}
        offsetTopMobile={16}
        offsetBottom={contentIsLoading ? 24 : 0}
        offsetBottomMobile={is743 ? 16 : 0}
      >
        {showcaseVisible && (
          <MagicBoxRow
            label={t("filter.showcase_title")}
            checked={showcase}
            style={{ color: theme.sortByColor }}
            onClick={() => {
              setQueryParams({ showcase: !showcase })
            }}
          />
        )}
        {!is743 ? (
          <ProjectsSearchBar
            isLoading={false}
            sorting={sorting}
            hideLeftBar
            hideRightButtons
            onSortingChange={(sorting) => {
              setQueryParams({ sorting }, { replace: true })
              localStorage.setItem("brg_sorting", String(sorting))
            }}
            sortingMethods={sortingMethods}
            isDarkTheme={!whiteTheme}
          />
        ) : (
          <MobileFilterSort
          onClick={() => {
            const current = Number(sorting);
            const calculatedSorting = current === 1 ? 20 : current === 20 ? 30 : current === 30 ? 2 : 1
              setQueryParams({ sorting: calculatedSorting }, { replace: true })
              localStorage.setItem("brg_sorting", String(calculatedSorting))
            }}
          >
            <SortIcon />
            {t(
              `sorting_type.${
                Number(sorting) === 1
                  ? "latest"
                  : Number(sorting) === 20
                  ? "relevant"
                  : Number(sorting) === 30
                  ? "shop"
                  : "popular"
              }`
            )}
          </MobileFilterSort>
        )}
      </FlexBox>
    )
  }, [
    showcase,
    currentFolder,
    folderId,
    sorting,
    t,
    requestTab,
    is743,
    hasShowcaseProjects,
    activeTabKey,
    contentIsLoading,
    counts,
    isMobile,
  ])

  const headerCtaBlock = useMemo(() => {
    if (is743) {
      return null
    }

    const shouldShowChannelButton = !!isMe && isMedia
    const shouldShowApplyButton = !!isMe && !isStartHSE

    if (!shouldShowChannelButton) {
      return null
    }


    return (
      <FlexBox offsetTop={24} offsetBottom={32} width="100%">
        <FlexBox gx={12} justify="flex-start">
          {shouldShowChannelButton && (
            <CreateChannelButton designerId={designer?.designerId || ""} />
          )}
          {/* {shouldShowApplyButton && (
            <ApplyMagistracyButton wide={!shouldShowChannelButton} />
          )} */}
        </FlexBox>
      </FlexBox>
    )
  }, [designer?.designerId, is743, isMedia, isMe, isStartHSE])

  const mobileButtons = useMemo(() => {
    const createButton = (isMe && is470 && (
      <MobileButton 
        onClick={() => history.push(
          CreateLinkTo.projectCreate()
        )} 
      >
        <ExploreButtonFilled>{t('nav.create_project')}</ExploreButtonFilled>
      </MobileButton>
    ))

    const channelButton = (is743 && isMedia && !!isMe && (
      <CreateChannelButton 
        designerId={designer?.designerId || ""} 
        isMe={isMe} 
      />
    ))
      

    const shouldShowApplyButton = !!isMe && !isStartHSE

    if (!shouldShowApplyButton && !channelButton && !createButton) {
      return null
    }

    return (
      <FlexBox offsetTopMobile={16} offsetBottomMobile={16} direction="column" gy={8}>
        {/* {shouldShowApplyButton && <ApplyMagistracyButton wide={!channelButton} />} */}
        {channelButton}
        {createButton}
      </FlexBox>
    )
  }, [isMedia, history, t, isMe, is470, is743, designer, isStartHSE])

  const content = useMemo(
    () => (
      <ProjectsButchControllerUltimate
        placement="bottom-start"
        filter={withShopFilter}
        loading={contentIsLoading || !tabDetermined}
        currentCategory="main"
        currentTab={requestTab}
        contextName={context}
        isMobileMoreVisible
        isMainPage
        handlers={handlers}
        designer={designer}
        isProfile
        // @ts-ignore
        isMe={isMe}
        accountId={designer?.accountId}
        designerId={designer?.designerId || ""}
      />
    ),
    [
      sortFilter,
      context,
      handlers,
      designer,
      contentIsLoading,
      tabDetermined,
      requestTab,
      activeTabKey,
      addTab,
      isNoProjects,
    ]
  )

  const countryData = useMemo(() => {
    const country: any = CountriesList.find(
      (country) =>
        country.alpha3Code.toLowerCase() ===
        computedDesigner?.countryCode?.toLowerCase()
    )
    return country
      ? {
          countryName:
            (i18n.language === "en" ? country?.name : country.nameRu) ?? "",
          url: country?.flag ?? "",
        }
      : undefined
  }, [computedDesigner?.countryCode, i18n.language])

  if (is743) {
    return (
      <>
        <MetaTags
          title={computedDesigner.fullName}
          description={[aboutQuotesSanitized]}
          images={designer?.avatar}
        />
        {
          // @ts-ignore
          <DesignerPageMobile
            filter={sortFilter}
            countryData={countryData}
            designerTeam={designerTeam}
            addTab={addTab}
            noProjects={noProjects}
            noProjectsRef={noProjectsRef?.current}
            shouldDisplayStudentRole={shouldDisplayRoles}
            onTabChange={onTabChange}
            onContextClick={onContextClick}
            roleString={shouldDisplayRoles ? roleString : ""}
            cityString={cityString}
            counts={counts}
            additionalCount={additionalCount}
            computedDesigner={computedDesigner}
            activeTabKey={
              activeTabKey === ADDITIONAL_TABS_SIGN ? addTab : activeTabKey
            }
            // @ts-ignore
            isMe={isMe}
            // @ts-ignore
            profile={profile}
            // @ts-ignore
            participantOpa={ParticipantOPA}
            designer={designer}
            filterList={filterList}
            buttons={mobileButtons}
            content={content}
            subscribe={<SubscribeInfo designer={designer} isMe={isMe} />}
            sortLine={sortingLine}
            tagId={tagId}
            setTagId={setTagId}
          />
        }
      </>
    )
  }

  if (
    !(isMe || hasEditProfilePolicy) &&
    !noProjects &&
    !noProjectsRef?.current
  ) {
    return (
      <FlexBox
        width={"100%"}
        align="center"
        alignMobile="center"
        height={"50vw"}
        heightMobile={"center"}
        justify="center"
        justifyMobile="center"
      >
        <LoaderSpinner text={""} />
      </FlexBox>
    )
  }

  if (isLoadingError) {
    return <ErrorLoadingResources />
  }

  if (
    designer &&
    !canViewDrafts &&
    !isBooks &&
    activeTabKey === DesignerTab.draftBooks
  ) {
    return <ErrorNotAllowedGeneric />
  }

  if (designer && !isBooks && activeTabKey === DesignerTab.books) {
    return <ErrorNotAllowedGeneric />
  }

  if (designer && !canViewDrafts && activeTabKey === DesignerTab.drafts) {
    return <ErrorNotAllowedGeneric />
  }

  if (
    designer &&
    !canViewCompetitions &&
    activeTabKey === DesignerTab.competitions
  ) {
    return <ErrorNotAllowedGeneric />
  }

  const renderServiceLink = (item: any, index: number) => {
    const renderedElement =
      typeof item.element === "function" ? item.element() : null

    return (
      <ServiceLink to={item?.link} key={index} onClick={!item?.link ? item?.action : undefined} target="_blank">
        {renderedElement}
      </ServiceLink>
    )
  }

  const serviceLinksComponents = Object.values(serviceLinks)?.map(
    (item, index) => renderServiceLink(item, index)
  )

  return (
    <DesignerCoreContainer id="ctr">
      <MetaTags
        title={computedDesigner.fullName}
        description={[aboutQuotesSanitized]}
        images={designer?.avatar}
      />
      {/* {!isNoProjects && <canvas id="cnv" height={0} width={0} />} */}
      <DesignerLayout
        isAlumniUser={shouldDisplayRoles ? isAlumni : false}
        // isLoading={isDesignerLoading}
        isLoadingContent={contentIsLoading}
        isHiddenStatus={
          !isEmployee &&
          !isStudent &&
          !isCooperator &&
          !hasEditProfilePolicy &&
          !isLPUEmployee
        }
        avatar={
          <Avatar
            imgBackColor={theme.app.backgroundColor}
            {...computedDesigner}
            fs={90}
          />
        }
        isAlumni={shouldDisplayRoles && <DesignerAlumni isAlumni={isAlumni} />}
        // @ts-ignore
        canFeedback={profile && !isMe}
        isMe={isMe}
        designer={designer}
        serviceLinks={serviceLinks}
        noProjects={noProjects}
        subscribe={<SubscribeInfo designer={designer} isMe={isMe} />}
        title={
          <Title color={theme.designerPage.textColor}>
            <FlexBox direction="row" align="center">
              {computedDesigner.fullName}
            </FlexBox>
          </Title>
        }
        more={null}
        social={
          isMe && (
            <FlexBox style={{ 
                position: 'absolute', 
                top: (isMedia && (!is743 && !isMe && designer || !is743 && !!isMe)) ? 60 : 0 , 
                right: 0 
              }}
            >
              <FlexBox
              direction="column"
              justify="center"
              style={{ 
                placeItems: "center", 
              }}
            >
              {computedDesigner.socialNetworks.map((value, i) => {
                if (
                  ["twitter", "telegram", "web-site"].includes(value?.type) &&
                  value?.link?.length > 0
                ) {
                  return (
                    <DesignerSocialNetwork
                      {...value}
                      key={value + i.toString()}
                    />
                  )
                }
              })}
              </FlexBox>
            </FlexBox>
          )
        }
        buttons={null}
        ctaBlock={headerCtaBlock}
        status={
          // shouldDisplayStudentRole && !!roleString?.length &&
          <FlexBox direction="column" directionMobile="column">
            <DesignerRole
              countryData={countryData}
              role={roleString}
              team={designerTeam}
              city={cityString}
              onClick={onContextClick}
              shouldDisplayStudentRole={shouldDisplayStudentRole}
            />
          </FlexBox>
        }
        description={(
          <AboutText
            color={theme.designerPage.textColor}
            style={{ lineHeight: "28px" }}
          >
            <ShowMoreContent
              lines={isTab && !is744BP? 11 : is744BP ? 9 : 3}
              more={t("show_more_text")}
              less={t("show_less_text")}
              expanded={false}
            >
              {aboutQuotesSanitized}
            </ShowMoreContent>
          </AboutText>
        )}
        // channelInfo={<ChannelInfo designerId={designer?.designerId ?? ''} isLoading={contentIsLoading} />}
        networks={( 
          <FlexBox gy={16} width="100%" justify="space-between" direction='column'>
            <FlexBox gx={24} align="center">
              {ParticipantOPA && designer && (
                <DesignerOpaButton id={designer?.designerId} />
              )}
              {!isIqMediia && serviceLinksComponents}
            </FlexBox>
            {/* {!is992BP && (
              <FlexBox width={'100%'} align='flex-end' justify='flex-end'>
                <CreateChannelButton designerId={designer?.designerId || ""}  />
              </FlexBox>
            )} */}
          </FlexBox>
        )}
        line={
          <DesignerSlider
            counts={counts}
            activeTabKey={activeTabKey}
            onTabChange={onTabChange}
            isMe={isMe}
            designer={designer}
            isLoading={contentIsLoading}
            whiteTheme={whiteTheme}
            additionalCount={additionalCount}
            addTab={addTab}
          />
        }
        folders={
          <DesignerFolders
            designerId={designer?.designerId || ""}
            tabName={activeTabKey}
            filterList={filterList}
            tagId={tagId}
            setTagId={setTagId}
            isMe={isMe}
          />
        }
        // cloudTags={(
        //   <DesignerTagsCloud designerId={designer?.designerId || ""} tabName={activeTabKey} filterList={filterList} tagId={tagId} setTagId={setTagId} visible={Boolean(showCloud)} />
        // )}
        mergeAccount={
          designer && isMe &&
          //@ts-ignore
          designer.mergeAccountsStatus !== 0 ?
          (CreateLinkTo.designerEdit(designer.designerId) + "?tab=account"):
          ''
          // && (
          //   <MergeAccountsWrapper>
          //     <MergeAccountsIcon />
          //     <Link
          //       to={
          //         CreateLinkTo.designerEdit(designer.designerId) +
          //         "?tab=account"
          //       }
          //     >
          //       {t("designer_edit.merge_accounts")}
          //     </Link>
          //   </MergeAccountsWrapper>
          // )
        }
        sortLine={sortingLine}
        content={content}
        minMargin={contentIsLoading}
      />
    </DesignerCoreContainer>
  )
}
import { Designer } from "@brg/api"
import { Avatar, Dropdown, FlexBox, IUseToasts, useBreakpoint } from "@brg/ui"
import { CoreContainer, LayoutConst } from "core/modules"
import { FC, lazy, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link, useHistory, useLocation } from "react-router-dom"
import { ErrorNotAllowedGeneric } from "shared/components/error-frames/error-not-allowed-generic"
import { ProjectsSearchBar } from "shared/components/projectsSearchBar/projectsSearchBar"
import { MagicBoxRow } from "shared/components/tagAdminProjectsSearchBar/tagAdminProjectsSearchBar"
import CountriesList from "shared/constants/countriesList"
import { isServer } from "shared/constants/isServer"
import { CreateLinkTo } from "shared/constants/linkTo"
import { CombinedEvents } from "shared/helpers/projectEvents"
import useQueryState from "shared/hooks/useQueryState"
import { SortIcon } from "shared/icons"
import MergeAccountsIcon from "shared/icons/MergeAccountsIcon"
import { LoaderSpinner } from "shared/modals/artzLegalsModal/LoaderAnimation"
import {
  ProfileFoldersProps,
} from "shared/reducers/ProfileFoldersSlice"
import styled, { DefaultTheme } from "styled-components"
import ProjectsButchControllerUltimate from "../../../core/controllers/ProjectsButchControllerUltimate"
import { AppTester } from "../../../supporting"
import { ErrorLoadingResources } from "../../components/error-frames"
import { DesignerTooltip } from "../../components/tooltips"
import { DesignerTab } from "../../constants/designerTab"
import { ComputedDesigner } from "../../helpers/computeData"
import { MobileFilterSort } from "../explore/exploreView"
import DesignerAlumni from "./components/designerAlumni"
import { DesignerLayout } from "./components/designerLayout"
import DesignerOpaButton from "./components/designerOpaButton"
import { ADDITIONAL_TABS_SIGN } from "./components/designerSliderItem"
import { DesignerSocialNetwork } from "./components/designerSocialNetwork"
import { EMPTY_CONTENT_TAB } from "./components/NoProjectsContent"
import { CreateChannelButton } from "./components/subscribe/CreateChannelButton"
import { ApplyMagistracyButton } from "./components/subscribe/ApplyMagistracyButton"
import { ServiceLink, Title } from "./designer"
import { AboutText, MergeAccountsWrapper, MobileButton, ProfileAbsoluteMoreContainer, ShowMoreContent } from "./styles"
import { SubscribeController } from "shared/components/Subscribe/SubscribeController"
import { BackdropContainer } from "shared/components/projectCard/ProjectCardTools";
import { ReactComponent as MoreCircleSvg } from 'shared/components/projectCard/assets/more-circle.svg';
import { ExploreButtonFilled } from "../explore/styles"
import DesignerRole from "./components/designerRole"
import { SortingTypeIndex } from "shared/constants/sortingType"

const DesignerFolders = isServer
    ? FlexBox
    : lazy(() => import("./components/DesignerFolders/DesignerFolders"));

const SubscribeInfo = isServer
    ? FlexBox
    : lazy(() => import("./components/subscribe/SubscribeInfo"));

const MetaTags = isServer
  ? FlexBox
  : lazy(() => import("../../components/MetaTags"))
const DesignerPageMobile = isServer
  ? FlexBox
  : lazy(() => import("./__mobile__/designer"))

const DesignerSlider = isServer
  ? FlexBox
  : lazy(() => import("./components/designerSlider"))

const DesignerCoreContainer = styled(CoreContainer)`
  margin-top: 14px;
  margin-bottom: 40px;

  @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
    margin-top: 10px;
  }

  .grid-w {
    padding-bottom: 24px !important;
    overflow: visible;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    .white_theme_project_underline {
      z-index: 0;
    }
  }

`

type SortFilter = { projectFilter: number; limit: number }
type NoProjects = { all: boolean; tab: boolean }
type FilterList = { authorTopProjectsFilter: any }

type PropsT = {
  activeTabKey: string
  addTab: string
  // buttons: ReactNode
  canViewCompetitions: boolean
  canViewDrafts: boolean
  computedDesigner: ComputedDesigner
  contentIsLoading: boolean
  counts: any
  designer?: Designer
  filterList: FilterList
  hasEditProfilePolicy: boolean
  handlers: CombinedEvents
  isBooks: boolean
  isLoadingError: boolean
  isGeo: boolean
  ignoreContext?: boolean
  isMobile: boolean
  isMe?: boolean
  isSubscribed?: boolean
  isIqMediia: boolean
  is744BP: boolean
  is743: boolean
  isNoProjects?: boolean
  noProjects?: NoProjects
  noProjectsRef: any
  onContextClick: () => void
  onTabChange: (tab: string, addTab?: string) => void
  profile: any
  ParticipantOPA?: boolean
  setTagId: (v: any) => void
  sortFilter: SortFilter
  serviceLinks: any
  shouldDisplayRoles: boolean
  tagId: string
  tabDetermined: boolean
  theme: DefaultTheme
  toasts: IUseToasts
  whiteTheme?: boolean
  hasShowcaseProjects?: boolean
  shouldDisplayStudentRole?: boolean,
  currentFolder?: string,
}

export const DesignerContent: FC<PropsT> = ({
  activeTabKey,
  addTab,
  canViewCompetitions,
  canViewDrafts,
  computedDesigner,
  contentIsLoading,
  counts,
  // contexts,
  designer,
  filterList,
  handlers,
  hasEditProfilePolicy,
  hasShowcaseProjects,
  is744BP,
  is743,
  isBooks,
  isGeo,
  isSubscribed,
  isIqMediia,
  isLoadingError,
  isMobile,
  isMe,
  isNoProjects,
  noProjectsRef,
  noProjects,
  onContextClick,
  onTabChange,
  ParticipantOPA,
  profile,
  serviceLinks,
  setTagId,
  shouldDisplayRoles,
  shouldDisplayStudentRole,
  sortFilter,
  tabDetermined,
  tagId,
  theme,
  whiteTheme,
    currentFolder,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { accountId: id = "" } = designer || {}
  const context = `profile${id}`
  const storedSorting = localStorage.getItem("brg_sorting")
  const defaultSorting = useMemo(() => {
    if (AppTester.isDeziiignContext()) {
      return 1;
    }
    return storedSorting || 20;
  }, []);
  const [
    { sorting = defaultSorting, showcase, folderId },
    setQueryParams,
  ] = useQueryState()

    const is470 = useBreakpoint(470);

  const isTab = useBreakpoint(1200)

  // // Доп. флаги
  const isEmployee =
    computedDesigner?.globalTypes?.includes("Employee") === true
  const isCooperator =
    computedDesigner?.globalTypes?.includes("Cooperator") === true
  const isAlumni =
    designer?.globalTypes !== null &&
    designer?.globalTypes?.includes("hsealumni")
  const isLPUEmployee =
    computedDesigner?.globalTypes?.includes("lpuemployee") === true
  const isStudent =
    computedDesigner?.globalTypes?.includes("Student") === true &&
    !isCooperator &&
    !isEmployee
  const isIfCIDStudent =
    !!computedDesigner?.globalTypes?.includes("Hsecreativestudent")

  const isLPU = AppTester.isLPUDesign()
  const isHSE = AppTester.isHSEDesign()
  const isMedia = AppTester.isMediiia();
  const isStartHSE = AppTester.isStartHSE();
  const { i18n } = useTranslation()

  const designerTeam = isIfCIDStudent ? t("ifcid") : computedDesigner.contextId

  // TODO Временная логика для отображения пункта магазин в дропдауне сортировки
  const withShopFilter = useMemo(() => ({
    ...sortFilter,
    ...(Number(sorting) === Number(SortingTypeIndex.shop) ? { hasProductCards: true} : {}),
  }), [sortFilter, sorting]);


  const hideAdditionalTabs = false

  const additionalCount = useMemo(
    () => ({
        // [DesignerTab.subscriptionsProjects]:
        //     counts[DesignerTab.subscriptionsProjects] || 0,
          //@ts-ignore
          [DesignerTab.subscriptions]:
            counts[DesignerTab.subscriptions] || 0,
          //@ts-ignore
          [DesignerTab.subscribers]:
            counts[DesignerTab.subscribers] || 0,
          [DesignerTab.educationSubscribes]:
            counts[DesignerTab.educationSubscribes] || 0,
          
      ...(hideAdditionalTabs
        ? {}
        : {
            //@ts-ignore
            [DesignerTab.workingMaterialsAuthor]:
              counts[DesignerTab.workingMaterialsAuthor],
            //@ts-ignore
            [DesignerTab.workingMaterialsCoauthor]:
              counts[DesignerTab.workingMaterialsCoauthor],
            //@ts-ignore
            [DesignerTab.workingMaterialsStudents]:
              counts[DesignerTab.workingMaterialsStudents],
          }),
    }),
    [counts, isMedia]
  )

  const roleString = useMemo(() => {
    const rolesArray = []

    if (isHSE) {
      if (isEmployee) {
        rolesArray.push(t("teacher_at_mob"))
      } else if (isCooperator) {
        rolesArray.push(t("cooperator_at_mob"))
      }
    }

    if (isLPU && isLPUEmployee) {
      rolesArray.push(t("teacher_at_mob"))
    }

    if (shouldDisplayStudentRole) {
      if (isStudent || isIfCIDStudent) {
        if (
          designer &&
          designer.rolesList &&
          designer.rolesList.includes("DPO")
        ) {
          rolesArray.push(t("listener_at_mob"))
        } else {
          rolesArray.push(t("student_at_mob"))
        }
      }

      if (rolesArray.length === 0) {
        return ""
      }

      const roles = rolesArray.join(" " + t("role_and") + " ")

      return isMobile ? roles + " " + t("role_at") : roles + " " + t("role_at")
    }

    return ""
  }, [isMobile, isEmployee, isCooperator, t, isLPUEmployee])

  const cityString = useMemo(() => {
    if (
      designer &&
      designer.rolesList &&
      designer.rolesList.includes("hseprm")
    ) {
      return "(" + t("online_bachelors_degree") + ")"
    } else {
      return ""
    }
  }, [designer, t])

  const requestTab = useMemo(() => {
    if (!isMe && isNoProjects) {
      return EMPTY_CONTENT_TAB
    } else if (activeTabKey === DesignerTab.subscribe) {
      return addTab;
    } else if (activeTabKey === ADDITIONAL_TABS_SIGN) {
      return addTab
    }
    return activeTabKey
  }, [isMe, isNoProjects, activeTabKey, addTab])

  //костыль под кавычки, если будут проблемы с другими символами, то надо сделать что-то нормальное в showMore
  const aboutQuotesSanitized = useMemo(() => {
    const leftQuotes = typeof computedDesigner.about === 'string'? computedDesigner.about.replaceAll('&laquo;', '«') : ''
    const rightQuotes = typeof leftQuotes === 'string'? leftQuotes.replaceAll('&raquo;', '»') : ''
    return rightQuotes
  }, [computedDesigner?.about])

  const sortingMethods = useMemo(() => {
    if (AppTester.isDeziiignContext()) {
      return [1, 2, 30];
    }
    return [1, 2, 20, 30];
  }, []);

  const sortingLine = useMemo(() => {
    if (folderId || currentFolder === ProfileFoldersProps.create) {
      return null
    }

    if (
      !hasShowcaseProjects ||
      ![
        DesignerTab.author,
        DesignerTab.students,
        DesignerTab.coauthor,
        DesignerTab.books,
      ]
        //@ts-ignore
        ?.includes(activeTabKey)
    ) {
      return null
    }

    const showcaseVisible = [
      "projects",
      "coauthor",
      "author",
      "students",
      "books",
    ]?.includes(activeTabKey)

    return (
      <FlexBox
        justifyMobile={is743 ? "space-between" : "start"}
        offsetTop={contentIsLoading ? -8 : 16}
        offsetTopMobile={16}
        offsetBottom={contentIsLoading ? 24 : 0}
        offsetBottomMobile={is743 ? 16 : 0}
      >
        {showcaseVisible && (
          <MagicBoxRow
            label={t("filter.showcase_title")}
            checked={showcase}
            style={{ color: theme.sortByColor }}
            onClick={() => {
              setQueryParams({ showcase: !showcase })
            }}
          />
        )}
        {!is743 ? (
          <ProjectsSearchBar
            isLoading={false}
            sorting={sorting}
            hideLeftBar
            hideRightButtons
            onSortingChange={(sorting) => {
              setQueryParams({ sorting }, { replace: true })
              localStorage.setItem("brg_sorting", String(sorting))
            }}
            sortingMethods={sortingMethods}
            isDarkTheme={!whiteTheme}
          />
        ) : (
          <MobileFilterSort
          onClick={() => {
            const current = Number(sorting);
            const calculatedSorting = current === 1 ? 20 : current === 20 ? 30 : current === 30 ? 2 : 1
              setQueryParams({ sorting: calculatedSorting }, { replace: true })
              localStorage.setItem("brg_sorting", String(calculatedSorting))
            }}
          >
            <SortIcon />
            {t(
              `sorting_type.${
                Number(sorting) === 1
                  ? "latest"
                  : Number(sorting) === 20
                  ? "relevant"
                  : Number(sorting) === 30
                  ? "shop"
                  : "popular"
              }`
            )}
          </MobileFilterSort>
        )}
      </FlexBox>
    )
  }, [
    showcase,
    currentFolder,
    folderId,
    sorting,
    t,
    requestTab,
    is743,
    hasShowcaseProjects,
    activeTabKey,
    contentIsLoading,
    counts,
    isMobile,
  ])

  const headerCtaBlock = useMemo(() => {
    if (is743) {
      return null
    }

    const shouldShowChannelButton = !!isMe && isMedia
    const shouldShowApplyButton = !!isMe && !isStartHSE

    if (!shouldShowChannelButton) {
      return null
    }


    return (
      <FlexBox offsetTop={24} offsetBottom={32} width="100%">
        <FlexBox gx={12} justify="flex-start">
          {shouldShowChannelButton && (
            <CreateChannelButton designerId={designer?.designerId || ""} />
          )}
          {/* {shouldShowApplyButton && (
            <ApplyMagistracyButton wide={!shouldShowChannelButton} />
          )} */}
        </FlexBox>
      </FlexBox>
    )
  }, [designer?.designerId, is743, isMedia, isMe, isStartHSE])

  const mobileButtons = useMemo(() => {
    const createButton = (isMe && is470 && (
      <MobileButton 
        onClick={() => history.push(
          CreateLinkTo.projectCreate()
        )} 
      >
        <ExploreButtonFilled>{t('nav.create_project')}</ExploreButtonFilled>
      </MobileButton>
    ))

    const channelButton = (is743 && isMedia && !!isMe && (
      <CreateChannelButton 
        designerId={designer?.designerId || ""} 
        isMe={isMe} 
      />
    ))
      

    const shouldShowApplyButton = !!isMe && !isStartHSE

    if (!shouldShowApplyButton && !channelButton && !createButton) {
      return null
    }

    return (
      <FlexBox offsetTopMobile={16} offsetBottomMobile={16} direction="column" gy={8}>
        {/* {shouldShowApplyButton && <ApplyMagistracyButton wide={!channelButton} />} */}
        {channelButton}
        {createButton}
      </FlexBox>
    )
  }, [isMedia, history, t, isMe, is470, is743, designer, isStartHSE])

  const content = useMemo(
    () => (
      <ProjectsButchControllerUltimate
        placement="bottom-start"
        filter={withShopFilter}
        loading={contentIsLoading || !tabDetermined}
        currentCategory="main"
        currentTab={requestTab}
        contextName={context}
        isMobileMoreVisible
        isMainPage
        handlers={handlers}
        designer={designer}
        isProfile
        // @ts-ignore
        isMe={isMe}
        accountId={designer?.accountId}
        designerId={designer?.designerId || ""}
      />
    ),
    [
      sortFilter,
      context,
      handlers,
      designer,
      contentIsLoading,
      tabDetermined,
      requestTab,
      activeTabKey,
      addTab,
      isNoProjects,
    ]
  )

  const countryData = useMemo(() => {
    const country: any = CountriesList.find(
      (country) =>
        country.alpha3Code.toLowerCase() ===
        computedDesigner?.countryCode?.toLowerCase()
    )
    return country
      ? {
          countryName:
            (i18n.language === "en" ? country?.name : country.nameRu) ?? "",
          url: country?.flag ?? "",
        }
      : undefined
  }, [computedDesigner?.countryCode, i18n.language])

  if (is743) {
    return (
      <>
        <MetaTags
          title={computedDesigner.fullName}
          description={[aboutQuotesSanitized]}
          images={designer?.avatar}
        />
        {
          // @ts-ignore
          <DesignerPageMobile
            filter={sortFilter}
            countryData={countryData}
            designerTeam={designerTeam}
            addTab={addTab}
            noProjects={noProjects}
            noProjectsRef={noProjectsRef?.current}
            shouldDisplayStudentRole={shouldDisplayRoles}
            onTabChange={onTabChange}
            onContextClick={onContextClick}
            roleString={shouldDisplayRoles ? roleString : ""}
            cityString={cityString}
            counts={counts}
            additionalCount={additionalCount}
            computedDesigner={computedDesigner}
            activeTabKey={
              activeTabKey === ADDITIONAL_TABS_SIGN ? addTab : activeTabKey
            }
            // @ts-ignore
            isMe={isMe}
            // @ts-ignore
            profile={profile}
            // @ts-ignore
            participantOpa={ParticipantOPA}
            designer={designer}
            filterList={filterList}
            buttons={mobileButtons}
            content={content}
            subscribe={<SubscribeInfo designer={designer} isMe={isMe} />}
            sortLine={sortingLine}
            tagId={tagId}
            setTagId={setTagId}
          />
        }
      </>
    )
  }

  if (
    !(isMe || hasEditProfilePolicy) &&
    !noProjects &&
    !noProjectsRef?.current
  ) {
    return (
      <FlexBox
        width={"100%"}
        align="center"
        alignMobile="center"
        height={"50vw"}
        heightMobile={"center"}
        justify="center"
        justifyMobile="center"
      >
        <LoaderSpinner text={""} />
      </FlexBox>
    )
  }

  if (isLoadingError) {
    return <ErrorLoadingResources />
  }

  if (
    designer &&
    !canViewDrafts &&
    !isBooks &&
    activeTabKey === DesignerTab.draftBooks
  ) {
    return <ErrorNotAllowedGeneric />
  }

  if (designer && !isBooks && activeTabKey === DesignerTab.books) {
    return <ErrorNotAllowedGeneric />
  }

  if (designer && !canViewDrafts && activeTabKey === DesignerTab.drafts) {
    return <ErrorNotAllowedGeneric />
  }

  if (
    designer &&
    !canViewCompetitions &&
    activeTabKey === DesignerTab.competitions
  ) {
    return <ErrorNotAllowedGeneric />
  }

  const renderServiceLink = (item: any, index: number) => {
    const renderedElement =
      typeof item.element === "function" ? item.element() : null

    return (
      <ServiceLink to={item?.link} key={index} onClick={!item?.link ? item?.action : undefined} target="_blank">
        {renderedElement}
      </ServiceLink>
    )
  }

  const serviceLinksComponents = Object.values(serviceLinks)?.map(
    (item, index) => renderServiceLink(item, index)
  )

  return (
    <DesignerCoreContainer id="ctr">
      <MetaTags
        title={computedDesigner.fullName}
        description={[aboutQuotesSanitized]}
        images={designer?.avatar}
      />
      {/* {!isNoProjects && <canvas id="cnv" height={0} width={0} />} */}
      <DesignerLayout
        isAlumniUser={shouldDisplayRoles ? isAlumni : false}
        // isLoading={isDesignerLoading}
        isLoadingContent={contentIsLoading}
        isHiddenStatus={
          !isEmployee &&
          !isStudent &&
          !isCooperator &&
          !hasEditProfilePolicy &&
          !isLPUEmployee
        }
        avatar={
          <Avatar
            imgBackColor={theme.app.backgroundColor}
            {...computedDesigner}
            fs={90}
          />
        }
        isAlumni={shouldDisplayRoles && <DesignerAlumni isAlumni={isAlumni} />}
        // @ts-ignore
        canFeedback={profile && !isMe}
        isMe={isMe}
        designer={designer}
        serviceLinks={serviceLinks}
        noProjects={noProjects}
        subscribe={<SubscribeInfo designer={designer} isMe={isMe} />}
        title={
          <Title color={theme.designerPage.textColor}>
            <FlexBox direction="row" align="center">
              {computedDesigner.fullName}
            </FlexBox>
          </Title>
        }
        more={null}
        social={
          isMe && (
            <FlexBox style={{ 
                position: 'absolute', 
                top: (isMedia && (!is743 && !isMe && designer || !is743 && !!isMe)) ? 60 : 0 , 
                right: 0 
              }}
            >
              <FlexBox
              direction="column"
              justify="center"
              style={{ 
                placeItems: "center", 
              }}
            >
              {computedDesigner.socialNetworks.map((value, i) => {
                if (
                  ["twitter", "telegram", "web-site"].includes(value?.type) &&
                  value?.link?.length > 0
                ) {
                  return (
                    <DesignerSocialNetwork
                      {...value}
                      key={value + i.toString()}
                    />
                  )
                }
              })}
              </FlexBox>
            </FlexBox>
          )
        }
        buttons={null}
        ctaBlock={headerCtaBlock}
        status={
          // shouldDisplayStudentRole && !!roleString?.length &&
          <FlexBox direction="column" directionMobile="column">
            <DesignerRole
              countryData={countryData}
              role={roleString}
              team={designerTeam}
              city={cityString}
              onClick={onContextClick}
              shouldDisplayStudentRole={shouldDisplayStudentRole}
            />
          </FlexBox>
        }
        description={(
          <AboutText
            color={theme.designerPage.textColor}
            style={{ lineHeight: "28px" }}
          >
            <ShowMoreContent
              lines={isTab && !is744BP? 11 : is744BP ? 9 : 3}
              more={t("show_more_text")}
              less={t("show_less_text")}
              expanded={false}
            >
              {aboutQuotesSanitized}
            </ShowMoreContent>
          </AboutText>
        )}
        // channelInfo={<ChannelInfo designerId={designer?.designerId ?? ''} isLoading={contentIsLoading} />}
        networks={( 
          <FlexBox gy={16} width="100%" justify="space-between" direction='column'>
            <FlexBox gx={24} align="center">
              {ParticipantOPA && designer && (
                <DesignerOpaButton id={designer?.designerId} />
              )}
              {!isIqMediia && serviceLinksComponents}
            </FlexBox>
            {/* {!is992BP && (
              <FlexBox width={'100%'} align='flex-end' justify='flex-end'>
                <CreateChannelButton designerId={designer?.designerId || ""}  />
              </FlexBox>
            )} */}
          </FlexBox>
        )}
        line={
          <DesignerSlider
            counts={counts}
            activeTabKey={activeTabKey}
            onTabChange={onTabChange}
            isMe={isMe}
            designer={designer}
            isLoading={contentIsLoading}
            whiteTheme={whiteTheme}
            additionalCount={additionalCount}
            addTab={addTab}
          />
        }
        folders={
          <DesignerFolders
            designerId={designer?.designerId || ""}
            tabName={activeTabKey}
            filterList={filterList}
            tagId={tagId}
            setTagId={setTagId}
            isMe={isMe}
          />
        }
        // cloudTags={(
        //   <DesignerTagsCloud designerId={designer?.designerId || ""} tabName={activeTabKey} filterList={filterList} tagId={tagId} setTagId={setTagId} visible={Boolean(showCloud)} />
        // )}
        mergeAccount={
          designer && isMe &&
          //@ts-ignore
          designer.mergeAccountsStatus !== 0 ?
          (CreateLinkTo.designerEdit(designer.designerId) + "?tab=account"):
          ''
          // && (
          //   <MergeAccountsWrapper>
          //     <MergeAccountsIcon />
          //     <Link
          //       to={
          //         CreateLinkTo.designerEdit(designer.designerId) +
          //         "?tab=account"
          //       }
          //     >
          //       {t("designer_edit.merge_accounts")}
          //     </Link>
          //   </MergeAccountsWrapper>
          // )
        }
        sortLine={sortingLine}
        content={content}
        minMargin={contentIsLoading}
      />
    </DesignerCoreContainer>
  )
}
